import React, { useState } from 'react';
import ReactApexChart from 'react-apexcharts'; // Make sure you have this library installed

const OverviewSplineGraph = () => {
    const [series] = useState([
        {
            name: 'series1',
            data: [31, 40, 28, 51, 42, 109, 100],
        },
    ]);

    return (
        <div>
            <div id="chart">
                <ReactApexChart
                    options={{
                        chart: {
                            height: 350,
                            type: 'area',
                            toolbar: {
                                show: false, // Hide the toolbar
                            },
                        },
                        colors: ['#4776E6'], // Change the color of the graph
                        dataLabels: {
                            enabled: false,
                        },
                        stroke: {
                            curve: 'smooth',
                        },
                        xaxis: {
                            type: 'datetime',
                            categories: [
                                '2018-09-19T00:00:00.000Z',
                                '2018-09-19T01:30:00.000Z',
                                '2018-09-19T02:30:00.000Z',
                                '2018-09-19T03:30:00.000Z',
                                '2018-09-19T04:30:00.000Z',
                                '2018-09-19T05:30:00.000Z',
                                '2018-09-19T06:30:00.000Z',
                            ],
                            labels: {
                                show: false, // Hide x-axis labels
                            },
                            axisBorder: {
                                show: false, // Hide x-axis border
                            },
                            axisTicks: {
                                show: false, // Hide x-axis ticks
                            },
                        },
                        yaxis: {
                            show: false, // Hide y-axis
                            axisBorder: {
                                show: false, // Hide y-axis border
                            },
                            axisTicks: {
                                show: false, // Hide y-axis ticks
                            },
                        },
                        grid: {
                            show: false, // Hide grid lines
                        },
                    }}
                    series={series}
                    type="area"
                    height={100}
                />
            </div>
            <div id="html-dist"></div>
        </div>
    );
};

export default OverviewSplineGraph;
